import { isB2B, isFrancePlatform } from '@/domains/core/settings/utils';
import { useAuth } from '@/domains/customerManagement/auth/hooks/useAuth';

export const useUserHasSubscription = () => {
  const auth = useAuth();
  return isFrancePlatform() && isB2B() && !!auth.b2b_subscription;
};
